var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-item-container"},[_c('div',{staticClass:"action-header"},[_vm._v(" "+_vm._s(_vm.heading)+" "),_c('v-icon',{staticClass:"action-close",attrs:{"color":"red","large":""},on:{"click":_vm.closeOptions}},[_vm._v("mdi-close")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }